import {getCookie, swalError, swalSuccessNoButton} from "./core";
import Swal from "sweetalert2";
import i18next from "i18next";
import Backend from "i18next-http-backend";
import storeLocale from "./i18n/bonus.json";

class BonusCampaigns {

    // Constructor
    constructor() {
        this.all();
        this.canceledBonus();
        this.claimCode();
        this.completedBonus();
        this.pendingBonus();
        this.userBonus();
    }

    // All bonus
    all() {
        let $table = $('#bonus-table');

        $table.DataTable({
            "ajax": {
                "url": $table.data('route'),
                "dataSrc": "data.campaigns"
            },
            "order": [[0, "asc"]],
            "columns": [
                {"data": "bonus"},
                {"data": "rollovers"},
                {"data": "actions", "className": "text-right"}
            ],
            "initComplete": function () {
                $('[data-toggle="tooltip"]').tooltip();
                BonusCampaigns.bonusInfoModal();
                BonusCampaigns.claim();
                BonusCampaigns.cancel();
            }
        });
    }

    // Bonus info modal
    static bonusInfoModal() {
        let $modal = $('#bonus-info-modal');
        $modal.on('show.bs.modal', function (event) {
            let $button = $(event.relatedTarget);
            $('#bonus-title').text($button.data('title'));
            $('#bonus-info').html($button.data('info'));
        })
    }

    // Cancel bonus
    static cancel() {
        let $button = $('.cancel-bonus');

        $button.click(function () {
            let campaign = $(this).data('campaign');
            let route = $(this).data('route');
            let locale = getCookie('language-js');
            locale = (locale === null || locale === '') ? 'en_US' : locale;

            i18next.use(Backend)
                .init({
                    lng: locale,
                    resources: storeLocale
                });

            Swal.fire({
                title: $(this).data('title'),
                html: $(this).data('description'),
                showCancelButton: true,
                confirmButtonColor: '#ff7600',
                cancelButtonColor: '#999',
                confirmButtonText: i18next.t('confirm'),
                cancelButtonText: i18next.t('Cerrar')
            }).then((result) => {
                if (result.value) {
                    $.ajax({
                        url: route,
                        type: 'post',
                        data: {campaign: campaign}
                    }).done(function (json) {
                        swalSuccessNoButton(json);
                        setTimeout(() => window.location.reload(), 1000);

                    }).fail(function (json) {
                        swalError(json);
                    });
                }
            });
        });
    }

    // Canceled bonus
    canceledBonus() {
        let $table = $('#canceled-bonus-table');

        $table.DataTable({
            "ajax": {
                "url": $table.data('route'),
                "dataSrc": "data.campaigns"
            },
            "order": [[0, "asc"]],
            "columns": [
                {"data": "bonus", "className": "align-middle"},
                {"data": "rollovers", "className": "align-middle"},
                {"data": "reason", "className": "align-middle"}
            ],
            "initComplete": function () {
                $('[data-toggle="tooltip"]').tooltip();
                BonusCampaigns.bonusInfoModal();
            }
        });
    }

    // Completed bonus
    completedBonus() {
        let $table = $('#completed-bonus-table');

        $table.DataTable({
            "ajax": {
                "url": $table.data('route'),
                "dataSrc": "data.campaigns"
            },
            "order": [[0, "asc"]],
            "columns": [
                {"data": "bonus", "className": "align-middle"},
                {"data": "rollovers", "className": "align-middle"}
            ],
            "initComplete": function () {
                $('[data-toggle="tooltip"]').tooltip();
                BonusCampaigns.bonusInfoModal();
            }
        });
    }

    // Claim bonus
    static claim() {
        let $button = $('.claim-bonus');

        $button.click(function () {
            let campaign = $(this).data('campaign');
            let locale = getCookie('language-js');
            locale = (locale === null || locale === '') ? 'en_US' : locale;

            i18next.use(Backend)
                .init({
                    lng: locale,
                    resources: storeLocale
                });

            Swal.fire({
                title: $(this).data('title'),
                html: $(this).data('description'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ff7600',
                cancelButtonColor: '#999',
                confirmButtonText: i18next.t('claim'),
                cancelButtonText: i18next.t('cancel')
            }).then((result) => {
                if (result.value) {
                    let $form = $('#claim-bonus-form');
                    $.ajax({
                        url: $form.attr('action'),
                        type: 'post',
                        data: $form.serialize() + `&campaign=${campaign}`
                    }).done(function (json) {
                        swalSuccessNoButton(json);
                        setTimeout(() => {
                            window.location.href = json.data.route;
                        }, 1000);

                    }).fail(function (json) {
                        swalError(json);
                    });
                }
            });
        });
    }

    // Claim bonus code
    claimCode() {
        let $button = $('.claim-bonus-code');
        let $form = $('#claim-bonus-code-form');

        $form.keypress(function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                $button.click();
            }
        });

        $button.click(function () {
            BonusCampaigns.claimBonusBonus($form, $button)
        });
    }

    // Claim bonus
    static claimBonusBonus(form, button) {
        let locale = getCookie('language-js');
        locale = (locale === null || locale === '') ? 'en_US' : locale;

        i18next.use(Backend)
            .init({
                lng: locale,
                resources: storeLocale
            });

        Swal.fire({
            title: button.data('title'),
            html: button.data('description'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff7600',
            cancelButtonColor: '#999',
            confirmButtonText: i18next.t('claim'),
            cancelButtonText: i18next.t('cancel')
        }).then((result) => {

            if (result.value) {
                $.ajax({
                    url: form.attr('action'),
                    type: 'post',
                    data: form.serialize()
                }).done(function (json) {
                    swalSuccessNoButton(json);
                    setTimeout(() => window.location.reload(), 1000);

                }).fail(function (json) {
                    swalError(json);
                });
            }
        });
    }

    // Pending bonus
    pendingBonus() {
        let $table = $('#pending-bonus-table');

        $table.DataTable({
            "ajax": {
                "url": $table.data('route'),
                "dataSrc": "data.campaigns"
            },
            "order": [[0, "asc"]],
            "columns": [
                {"data": "bonus", "className": "align-middle"},
                {"data": "rollovers", "className": "align-middle"},
                {"data": "actions", "className": "align-middle"}
            ],
            "initComplete": function () {
                BonusCampaigns.bonusInfoModal();
                BonusCampaigns.claim();
            }
        });
    }

    // User bonus
    userBonus() {
        let $table = $('#user-bonus-table');

        $table.DataTable({
            "ajax": {
                "url": $table.data('route'),
                "dataSrc": "data.campaigns"
            },
            "order": [[0, "asc"]],
            "columns": [
                {"data": "bonus", "className": "align-middle"},
                {"data": "rollovers", "className": "align-middle"},
                {"data": "actions", "className": "text-right align-middle"}
            ],
            "initComplete": function () {
                $('[data-toggle="tooltip"]').tooltip();
                BonusCampaigns.bonusInfoModal();
                BonusCampaigns.cancel();
            }
        });
    }
}

window.BonusCampaigns = BonusCampaigns;